module.exports = __webpack_public_path__ + "img/service4.dcc26176.png";